import { useCallback } from 'react'
import { useImperativeQuery } from '../lib/apolloClient'
import { GET_ADDRESS_COUNTIES } from '../graphql/queries'

/**
 * A hook that provides a function to fetch address counties only when needed
 */
export const useAddressCountiesService = () => {
  const getAddressCountiesQuery = useImperativeQuery(GET_ADDRESS_COUNTIES)

  // Function to fetch counties data only when explicitly called
  const fetchAddressCounties = useCallback(
    async (country: string) => {
      if (!country) return []

      try {
        const response = await getAddressCountiesQuery({ input: { country } })
        return response?.data?.getAddressCounties ?? []
      } catch (error) {
        console.error(`Error fetching counties: ${country}`, error)
        return []
      }
    },
    [getAddressCountiesQuery]
  )

  return { fetchAddressCounties }
}
